// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Q-hi","label":"styles_label__2r1Hu"};